/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-string-refs */
import { closeModal } from "action/modal/closeModal";
import PAText from "component/design-system/typography/PAText/PAText";
import Link from "next/link";
import { useDispatch } from "react-redux";
import { getProductHeading } from "../../../../util/product/get-product-heading";
import CardActions from "../__components__/card-actions/CardActions";
import CardPartNumber from "../__components__/card-part-number/CardPartNumber";
import CardImage from "../__components__/product-thumbnail/ProductThumbnail";
import styles from "../vertical-product-card/vertical-product-card.module.scss";

const MediumVerticalProductCard = ({ product = {} }: any) => {
  const dispatch = useDispatch();

  return (
    <div className={styles.vertical_product_card_wrapper}>

      <div className={`${styles.product_card}`}>

        <div>

          <CardActions product={product} />

          <Link
            href={product.canonicalUrl}
            className={styles.item_link}
            onClick={() => dispatch(closeModal())}>

            <div>

              <CardImage product={product} size={80} />

              <div className={`${styles.item_details} text-left`}>

                <PAText component="h3" className={`${styles.item_description} p-0 m-0`}>

                  {getProductHeading(product)}
                </PAText>

                <div>{product.manufacturer}</div>

                <CardPartNumber product={product} />
              </div>
            </div>

          </Link>
        </div>
      </div>
    </div>
  );
};

export default MediumVerticalProductCard;
